export default __webpack_public_path__ + "static/media/KBANK.ec8e1398.png";